export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40b82471515a876d6f51a074f5c3c99001c37f12a9&name=revalidateCommunity!'